// import React from 'react';
// import '../styles/Logo.css';

// const Logo = () => (
//   <div className="logo">
//     <div className="logo-icon">
//       <svg className="logo-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M3 9L12 4L21 9V20H3V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//         <path d="M9 14V20H15V14H9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//         <path d="M21 9L17 6M17 6L12 2M17 6V2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//       </svg>
//     </div>
//     <div className="logo-text">
//       <span className="logo-title">Turtles Bay</span>
//       <span className="logo-subtitle">— Lakshadweep —</span>
//     </div>
//   </div>
// );

// export default Logo;

import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Logo.css';

const Logo = ({isScrolled}) => {

  const logoSrc = !isScrolled
    ? '/images/Turtlebay brand-white.png' 
    : '/images/Turtle-logo-teal.png'; 
  return (
    <Link to="/" className="logo-link">
      <div className="logo">
        <div className="logo-container">
          <img src={logoSrc} alt="" className="logo-image" />
        </div>
        <div className="logo-text-container">
          <span className="logo-text-main">TURTLE'S BAY</span>
          <span className="logo-text-tagline">Luxury Hotel and Living</span>
        </div>
      </div>
    </Link>
  );
};

export default Logo;
